import React from 'react';
import { withRouter } from 'react-router';
import Datatable from '../../components/molecules/datatable';
import useStyles from './styles';
import { DummyData, DummyColumns } from './configuration';

interface IProps {}

const Datatables = (props: IProps) => {
  const classes = useStyles();
  const sortField = React.useRef<string>(DummyColumns[0].id);
  const sortType = React.useRef<'asc' | 'desc'>('asc');

  const paging = {
    page: 0,
    pageSize: DummyColumns.length,
    total: DummyColumns.length,
  };

  return (
    <div>
      <Datatable
        paging={paging}
        data={DummyData}
        sorting={{
          sortField: sortField.current,
          order: sortType.current,
        }}
        // sortField={sortField.current}
        // order={sortType.current}
        loading={false}
        columns={DummyColumns}
      />
    </div>
  );
};

export default withRouter(Datatables);
